import IcPdf from './IcPdf'

export default IcPdf
